import { getDataMapper, mapArray, mapField } from "@/shared";

export const mapRefusalTypeFromServer = getDataMapper({
    id: mapField("id", Number),
    title: mapField("title"),
    const: mapField("const"),
});
export const mapRefusalTypesFromServer = mapArray(mapRefusalTypeFromServer);
